import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/opt/build/repo/src/components/Analytics/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/opt/build/repo/src/components/ui/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/ui/Logo/Logo.tsx");
